import { Localization } from "@mui/material/locale";
import { i18n, Locales } from "../../../@commons/locales";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type localeKeys = "fa-IR" | "en-US";
export type localeLanguage = "Persian" | "English";
export type localeShort = "Fa" | "En";
export type localeDirections = "rtl" | "ltr";

interface ILocale {
  key: localeKeys;
  language: localeLanguage;
  short: localeShort;
  direction: localeDirections;
  muiLocale: Localization;
}

const initialState: ILocale =
  Locales.find((L) => L.key === i18n.language) || Locales[0];

const localeSlice = createSlice({
  name: "Locale",
  initialState,
  reducers: {
    changeLanguage(state: ILocale, action: PayloadAction<localeKeys>) {
      const locale = Locales.find((L) => L.key === action.payload);
      if (locale) {
        state.key = locale.key;
        state.direction = locale.direction;
        state.language = locale.language;
        state.muiLocale = locale.muiLocale;
        state.short = locale.short;
        i18n.changeLanguage(locale.key);
      }
    },
  },
  extraReducers: {},
});

export const { changeLanguage } = localeSlice.actions;
export default localeSlice.reducer;
export type { ILocale };
